/* mw-plp: filtros, ordem e paginacao da colecao e da busca SEM recarregar
   (P9 do lancamento, 2026-09-25). Pedido do dono: "ao clicar em um filtro a
   pagina nao se mova e nao recarregue" - a testadora usava zoom alto num
   Android, e cada recarga a devolvia ao topo e desfazia o zoom de pinca.

   Progressive enhancement: filtros, "Todos", faixas de preco, "Limpar filtros"
   e paginacao continuam <a href> e a ordem continua um <form> GET. Sem este
   arquivo tudo navega como antes. Com ele:
   - o clique (ou a troca da ordem) busca a MESMA URL pela Section Rendering API
     (?sections=<id da section>, o id lido do wrapper .shopify-section, nunca o
     numero do template, que muda por tema) e troca so as regioes marcadas com
     data-mw-plp-r (barra e grade);
   - a URL acompanha (pushState, sem o sections=), e voltar/avancar refaz pelo
     cache com a rolagem guardada;
   - a regiao clicada fica no mesmo ponto da tela (delta medido antes e depois);
     paginacao leva ao topo da GRADE, nunca ao topo da pagina;
   - o foco volta ao controle equivalente pela chave estavel data-mw-fk;
   - o titulo da aba vem da grade nova (data-mw-plp-titulo, o mesmo snippet do
     <title> do layout), decodificado como o navegador le o <title>;
   - um role="status" persistente (fora das regioes trocadas) anuncia o texto
     que o Liquid deixou em data-mw-anuncio;
   - qualquer falha, ou resposta que nao chega em ESPERA ms, vira
     location.assign(url), o comportamento de antes.

   Os chips de ocasiao NAO passam por aqui: levam a outra colecao e navegam
   (decisao do dono). A ancora #ocasioes deles faz a pagina nova abrir na faixa;
   este arquivo so acerta a faixa abaixo do cabecalho fixo e deixa o chip ativo
   visivel na rolagem lateral (scrollLeft; scrollIntoView rolaria a pagina).

   Roda ANTES do mw-core/mw-cart (defer dentro da section vem antes dos scripts
   do fim do body): nada aqui le window.MW ou window.MWCart na inicializacao. O
   carrinho chega pelo evento mw:cart.

   iOS 12 (o iPad do dono): ES5, sem ?. nem ??, sem AbortController (a resposta
   velha morre pelo contador de geracao), sem requestSubmit, sem
   toggleAttribute. Sem history.scrollRestoration = 'manual': ele quebraria a
   volta da pagina do produto para a lista na mesma altura. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.querySelector('[data-mw-plp]');
  var secao = root && root.closest('.shopify-section');
  if (!secao || !history.pushState || !window.fetch) return;

  var ID = secao.id.slice(16); /* "shopify-section-".length */
  var R = 'data-mw-plp-r';
  var FK = 'data-mw-fk';
  var FOCAVEL = 'a[href],button,select';
  /* fetch nao tem prazo proprio: pendurado, deixaria a grade esmaecida */
  var ESPERA = 10000;
  var status = root.querySelector('[data-mw-plp-status]');
  var chips = root.querySelector('.mw-plp-chips');
  var cache = {};
  var fila = [];
  var geracao = 0;
  var seq = Date.now();
  /* recarregou numa entrada que ja era nossa: continua com a chave dela */
  var hs = history.state;
  var chave = hs && hs.mwPlp ? hs.k : String(seq);
  var ys = {};
  var atual = limpa(location.href);
  var carrinho = null;
  var tAnuncio;

  function limpa(u) { return u.split('#')[0]; }
  function qsa(s, r) { return (r || root).querySelectorAll(s); }
  function regiao(nome, r) { return (r || root).querySelector('[' + R + '="' + nome + '"]'); }
  function nomes(lista) {
    var n = [];
    for (var i = 0; i < lista.length; i++) n.push(lista[i].getAttribute(R));
    return n.join();
  }

  /* altura do cabecalho grudado no topo, medida agora (o --mw-header-h do
     mw-core pode ainda nao existir no primeiro carregamento) */
  function altCab() {
    var c = doc.querySelector('.mw-header');
    return c ? c.getBoundingClientRect().height : 0;
  }
  /* o que fica preso no topo da tela: o cabecalho e, no desktop, a barra de
     filtros sticky (no celular ela e estatica e sai da tela com a rolagem) */
  function topoLivre() {
    var h = altCab();
    var b = regiao('barra');
    if (b && /sticky/.test(getComputedStyle(b).position)) h += b.offsetHeight;
    return h;
  }

  function guardar(u, html) {
    if (!(u in cache)) {
      fila.push(u);
      if (fila.length > 10) delete cache[fila.shift()];
    }
    cache[u] = html;
  }

  function buscar(u) {
    if (u in cache) return Promise.resolve(cache[u]);
    return fetch(u + (u.indexOf('?') < 0 ? '?' : '&') + 'sections=' + ID, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function (j) {
        var h = j[ID];
        if (!h) throw 0;
        guardar(u, h);
        return h;
      });
  }

  /* o = { origem: elemento clicado, pag: paginacao, pop: state do popstate } */
  function ir(u, o) {
    u = limpa(u);
    /* "Todos" ja ativo aponta para a propria URL: nada a trocar */
    if (u === atual && !o.pop) return;
    var g = ++geracao;
    /* a pagina de chegada entra no cache como esta, para o "voltar" ate ela
       nao precisar de rede */
    if (!(atual in cache)) guardar(atual, secao.innerHTML);
    if (!(u in cache)) root.setAttribute('aria-busy', 'true');
    var prazo = setTimeout(function () { desistir(g, u); }, ESPERA);
    buscar(u)
      .then(function (html) {
        clearTimeout(prazo);
        if (g === geracao) trocar(u, html, o);
      })
      .catch(function () {
        clearTimeout(prazo);
        desistir(g, u);
      });
  }

  /* a pagina inteira, como sem este arquivo; a geracao sobe para a resposta
     que ainda chegar nao trocar nada no meio da navegacao */
  function desistir(g, u) {
    if (g !== geracao) return;
    geracao++;
    location.assign(u);
  }

  function trocar(u, html, o) {
    var tmp = doc.createElement('div');
    tmp.innerHTML = html;
    var velhas = qsa('[' + R + ']');
    var novas = qsa('[' + R + ']', tmp);
    /* a resposta tem que trazer as MESMAS regioes; senao a pagina inteira */
    if (!velhas.length || nomes(velhas) !== nomes(novas)) throw 0;

    var ativo = doc.activeElement;
    var origem = o.origem || (root.contains(ativo) ? ativo : null);
    var regOrigem = origem && origem.closest('[' + R + ']');
    var nomeReg = regOrigem && regOrigem.getAttribute(R);
    var antes = regOrigem ? regOrigem.getBoundingClientRect().top : 0;
    var fk = origem && origem.getAttribute(FK);
    var i;

    /* sem nenhum mw:cart ainda: o que o mw-cart ja marcou na tela vale */
    var marcados = {};
    if (!carrinho) {
      qsa('[data-mw-card][data-mw-na-sacola]').forEach(function (c) {
        marcados[c.getAttribute('data-handle')] = 1;
      });
    }

    if (!o.pop) {
      history.replaceState({ mwPlp: 1, k: chave, y: pageYOffset }, '');
      chave = String(++seq);
      history.pushState({ mwPlp: 1, k: chave }, '', u);
    }
    atual = u;

    for (i = 0; i < velhas.length; i++) velhas[i].parentNode.replaceChild(novas[i], velhas[i]);
    root.removeAttribute('aria-busy');
    remarcar(marcados);

    var grade = regiao('grade');
    var tt = grade && grade.getAttribute('data-mw-plp-titulo');
    if (tt) {
      /* o valor e o que o Liquid escreveu no <title> (a Shopify ja escapa o
         termo da busca): o textarea decodifica as entidades sem montar HTML */
      var ta = doc.createElement('textarea');
      ta.innerHTML = tt;
      doc.title = ta.value;
    }
    if (o.pop) {
      var y = ys[o.pop.k];
      if (y == null) y = o.pop.y;
      if (y != null) scrollTo(0, y);
    } else if (o.pag) {
      if (grade) scrollBy(0, grade.getBoundingClientRect().top - topoLivre());
    } else {
      var nova = nomeReg && regiao(nomeReg);
      if (nova) scrollBy(0, nova.getBoundingClientRect().top - antes);
      /* barra sticky com a rolagem funda (desktop): a lista nova comeca logo
         abaixo dela, e nao no meio. A barra continua no mesmo lugar. */
      var d = grade ? grade.getBoundingClientRect().top - topoLivre() : 0;
      if (d < 0) scrollBy(0, d);
    }

    var alvo = null;
    if (fk) {
      qsa('[' + FK + ']').forEach(function (el) {
        if (!alvo && el.getAttribute(FK) === fk) alvo = el;
      });
    }
    /* sem equivalente (paginacao, "Limpar filtros", ou o controle focado sumiu
       no voltar/avancar): o primeiro controle da mesma regiao, que na grade e o
       nome do primeiro rotulo. So quando o foco estava numa regiao trocada. */
    if (!alvo && nomeReg && !doc.contains(origem)) {
      var r = regiao(nomeReg);
      alvo = r && r.querySelector(FOCAVEL);
    }
    if (alvo) alvo.focus({ preventScroll: true });

    anunciar();
  }

  /* o ponto "ja no carrinho" dos cards novos. Mesma regra do atualizarHeader do
     mw-cart.js e do Liquid do card-produto (um handle no carrinho = card
     marcado, menos a linha de presente de evento, _mw_ev, que e outra compra):
     se ela mudar la, muda aqui. */
  function remarcar(marcados) {
    var h = marcados;
    if (carrinho) {
      h = {};
      (carrinho.items || []).forEach(function (it) {
        if (!(it.properties || {})._mw_ev) h[it.handle] = 1;
      });
    }
    qsa('[data-mw-card][data-handle]').forEach(function (c) {
      if (h[c.getAttribute('data-handle')]) c.setAttribute('data-mw-na-sacola', '');
      else if (carrinho) c.removeAttribute('data-mw-na-sacola');
    });
  }

  function anunciar() {
    var g = regiao('grade');
    var a = g && (g.hasAttribute('data-mw-anuncio') ? g : g.querySelector('[data-mw-anuncio]'));
    if (!a || !status) return;
    var t = (a.getAttribute('data-mw-anuncio') || a.textContent).trim();
    /* esvaziar e preencher depois faz o leitor repetir um texto igual */
    status.textContent = '';
    clearTimeout(tAnuncio);
    tAnuncio = setTimeout(function () { status.textContent = t; }, 100);
  }

  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !root.contains(a)) return;
    var pag = !!a.closest('[data-mw-plp-pag]');
    if (!pag && !a.hasAttribute(FK)) return;
    if (a.target || a.host !== location.host || a.pathname !== location.pathname) return;
    e.preventDefault();
    ir(a.href, { origem: a, pag: pag });
  });

  /* a ordem: o onchange inline do select so submete quando este arquivo nao
     carregou (window.MWPlp ausente). Aqui a URL sai dos campos do proprio form,
     num laco simples (FormData iteravel e URLSearchParams(form) nao existem no
     iOS 12). */
  doc.addEventListener('change', function (e) {
    var f = e.target.form;
    if (!f || !f.hasAttribute('data-mw-plp-ordem') || !root.contains(f)) return;
    var q = [];
    for (var i = 0; i < f.elements.length; i++) {
      var el = f.elements[i];
      if (el.name && !el.disabled) q.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
    }
    ir(f.action.split('?')[0] + '?' + q.join('&'), { origem: e.target });
  });

  addEventListener('popstate', function (e) {
    var s = e.state;
    if (!s || !s.mwPlp) return;
    chave = s.k;
    if (limpa(location.href) !== atual) ir(location.href, { pop: s });
  });

  /* a altura de cada entrada do historico, para voltar e avancar nela */
  addEventListener('scroll', function () { ys[chave] = pageYOffset; }, { passive: true });

  doc.addEventListener('mw:cart', function (e) { carrinho = e.detail; });

  /* ---------- faixa de chips de ocasiao ---------- */
  if (chips) {
    var PX = 'mw_plp_x';
    var veio = location.hash === '#' + chips.id;
    /* a ancora poe a faixa no topo, mas o cabecalho grudado a cobre onde o
       scroll-margin-top nao existe (Safari abaixo de 14.1) ou ainda vale o
       fallback do --mw-header-h (no celular o real e maior). So mexe se a faixa
       estiver debaixo do cabecalho: rolagem restaurada pelo navegador (recarga,
       voltar) fica onde esta. */
    var alinhar = function () {
      var t = chips.getBoundingClientRect().top;
      var h = altCab();
      if (t > -2 && t < h - 1) scrollBy(0, t - h);
    };
    chips.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        try { sessionStorage.setItem(PX, chips.scrollLeft); } catch (err) { /* bloqueado */ }
      }
    });
    if (veio) {
      /* a faixa da pagina nova comeca de onde a anterior estava: o chip tocado
         fica no mesmo lugar */
      try {
        var x = sessionStorage.getItem(PX);
        sessionStorage.removeItem(PX);
        if (x) chips.scrollLeft = +x;
      } catch (err) { /* bloqueado */ }
      alinhar();
      addEventListener('load', alinhar);
    }
    var ch = chips.querySelector('[aria-current]');
    if (ch) {
      var r = ch.getBoundingClientRect();
      var f = chips.getBoundingClientRect();
      if (r.left < f.left || r.right > f.right) {
        chips.scrollLeft += r.left - f.left - (parseFloat(getComputedStyle(chips).paddingLeft) || 0);
      }
    }
  }

  window.MWPlp = { ir: ir };
})();
